<template>
  <div class="login auth-page" id="auth" :style="authStyle" v-if="!showLoader">
    <div class="container" v-if="company">
      <div class="row">
        <div class="col-12">
          <div class="card card-container card-container--wide mt-5">
            <div class="row mb-2 pb-2 border-bottom no-gutters" v-if="company && company.languages.length > 1">
              <div class="col-5 ml-auto mb-2 text-right">
                <select
                  class="border shadow-none"
                  name="language-select"
                  id="language-select"
                  v-model="language"
                  @change="updateLanguage"
                >
                  <option :value="null" disabled>
                    {{ 'settings.changeYourLanguage' | translate }}
                  </option>
                  <option v-for="lang in company.languages" :value="lang.localeCode" :key="lang.languageId">
                    {{ lang.languageName }}
                  </option>
                </select>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <h2 class="my-4">{{ $t('verifyEmail.title') }}</h2>
                <span class="d-block my-3">{{ $t('verifyEmail.subtitle') }}</span>
                <form class="form-signin mt-3" @submit.prevent="verify">
                  <label for="inputEmail" class="form-label mb-1">Work email</label>
                  <input
                    type="email"
                    id="inputEmail"
                    class="form-control"
                    :class="{ 'is-invalid': workEmailError }"
                    :placeholder="$t('verifyEmail.placeholder')"
                    required
                    autofocus
                    v-model="workEmail"
                  />
                  <div v-if="workEmailError" class="invalid-feedback d-block">
                    {{ workEmailError }}
                  </div>

                  <primary-button :loading="loading" size="large" class="btn-block btn-signin mt-4" type="submit">
                    {{ $t('verifyEmail.next') }}
                  </primary-button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="pt-24" v-else>
    <loader />
  </div>
</template>

<script>
import authMixin from '../../mixins/auth';
import { mapGetters } from 'vuex';
import { updateLanguage } from '@shared/translations';

export default {
  mixins: [authMixin],
  data() {
    return {
      workEmail: this.$route.query.workEmail || '',
      workEmailError: null,
      loading: false,
      language: null,
      showLoader: false
    };
  },
  computed: {
    ...mapGetters('settings', ['company', 'style']),
    authStyle() {
      if (this.style?.loginBackground?.url) {
        return {
          'background-image': `url(${this.style.loginBackground.url}) !important`,
          'background-size': 'cover !important',
          'background-position': 'center center',
          'background-repeat': 'no-repeat',
          'background-attachment': 'fixed'
        };
      }
      return {};
    },
    companyId() {
      return this.company?.id;
    }
  },
  mounted() {
    const localUser = window.localStorage.getItem('onboarding_user');
    if (localUser) {
      const parsed = JSON.parse(localUser);
      this.language = parsed.language || null;
    }
  },
  methods: {
    updateLanguage() {
      const lang = this.company.languages.find((l) => l.localeCode === this.language);
      if (!lang) return;

      const user = {
        language: this.language,
        languageId: lang.languageId
      };

      window.localStorage.setItem('onboarding_user', JSON.stringify(user));
      window.localStorage.setItem('onboarding_defaultLanguage', this.language);
      updateLanguage(this.language);
    },
    verify() {
      this.loading = true;
      this.$http
        .post(`/v2/companies/${this.companyId}/users/emails/verification-requests`, {
          workEmail: this.workEmail
        })
        .then(() => {
          this.loading = false;
          this.$router.push({
            name: 'verifyEmailCode',
            query: {
              workEmail: this.workEmail
            }
          });
        })
        .catch((error) => {
          this.loading = false;
          const errors = error?.response?.data?.errors || [];

          if (errors.includes('time_limit_not_passed')) {
            this.workEmailError = this.$t('verifyEmail.timeLimitError');
          } else if (errors.includes('unable_to_verify_email')) {
            this.workEmailError = this.$t('verifyEmail.domainError');
          } else {
            this.workEmailError = this.$t('notifications.error');
          }
        });
    }
  }
};
</script>

<style lang="scss" scoped>
@import './auth.scss';
</style>
